module.exports = __webpack_public_path__ + "img/snappay-gif-mobile.921bbb66.gif";